import { gql } from '@apollo/client';

export const CITY_PMC_FIELDS = gql`
  fragment CityPmcFields on PmcsResponse {
    content {
      pmcId
      countryCode
      name
      reservationType
      physicalZoneUid
      salesLocationUid
      parkingSpaceType
      countryCode
      visibility
      prices {
        annualPrice
        thirtyDayPrice
        monthlyPrice
        halfYearPrice
        quarterlyPrice
        validity {
          validFrom
        }
        serviceFee
      }
      billingInterval
      billingTypes
      availability {
        availability
        details {
          pmc
        }
      }
      parkZone {
        name
        uid
        spotMap
        area
        locationType
        address {
          marker
          street
          number
          city
          distance
        }
        commercialZoneView {
          zoneCode
          name
        }
        markerType
      }
      salesLocation {
        uid
        name
        parkingZones
      }
      permitType
      paymentMethods
      billingIntervals
      onlineBookingFlexibleStartDate
      startSellingDate
      forResidentsOnly
      vendorId
      automaticOnlineOrderActivation
      attachmentPolicy
      maxLicensePlatesPerQuantity
    }
  }
`;
